import type { Module } from 'vuex';
import { Exchange } from '@/types/Exchange';
import {RootState} from "@/store";

export interface ExchangeState {
  exchange: Exchange | null;
  deleted: boolean;
}

const exchangeModule: Module<ExchangeState, RootState> = {
  namespaced: true,

  state: (): ExchangeState => ({
    exchange: null,
    deleted: false,
  }),

  mutations: {
    setExchange(state, payload: { idExchange: number; code: string; locked: boolean; blockStore: boolean; blockStream: boolean; }) {
      state.exchange = new Exchange(
        payload.idExchange,
        payload.code,
        payload.locked,
        payload.blockStore,
        payload.blockStream,
      );
      state.deleted = false;
    },
    setExchangeUpdate(state, payload: { idExchange: number; code?: string; locked?: boolean; blockStore?: boolean; blockStream?: boolean; }) {
      if (!state.exchange || state.exchange.idExchange !== payload.idExchange) return;
      if (payload.code !== undefined) state.exchange.code = payload.code;
      if (payload.locked !== undefined) state.exchange.locked = payload.locked;
      if (payload.blockStore !== undefined) state.exchange.blockStore = payload.blockStore;
      if (payload.blockStream !== undefined) state.exchange.blockStream = payload.blockStream;
    },
    setExchangeDelete(state, payload: { idExchange: number }) {
      if (state.exchange?.idExchange === payload.idExchange) {
        state.deleted = true;
      }
    },
    setExchangeLock(state, payload: { idExchange: number }) {
      if (state.exchange?.idExchange === payload.idExchange) {
        state.exchange.locked = true;
      }
    },
    setExchangeUnlock(state, payload: { idExchange: number }) {
      if (state.exchange?.idExchange === payload.idExchange) {
        state.exchange.locked = false;
      }
    },
    clearExchange(state) {
      state.exchange = null;
      state.deleted = false;
    },
  },

  actions: {
    wsSetExchange({ commit }, payload) {
      commit('setExchange', payload);
    },
    wsExchangeUpdate({ commit }, payload) {
      commit('setExchangeUpdate', payload);
    },
    wsExchangeDelete({ commit }, payload) {
      commit('setExchangeDelete', payload);
    },
    wsExchangeLock({ commit }, payload) {
      commit('setExchangeLock', payload);
    },
    wsExchangeUnlock({ commit }, payload) {
      commit('setExchangeUnlock', payload);
    },
    clearExchange({ commit }) {
      commit('clearExchange');
    },
    wsSetEmptyExchange({ commit }) {
      commit('clearExchange');
    },
  },
};

export default exchangeModule; 